/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type ComposedProps = Props & WithI18nProps;

class UpgradingBanner extends Component<ComposedProps> {
  state = {
    dismissedBanner: false
  };

  render() {
    const { i18n } = this.props;

    return (
      <div style={{ marginBottom: '24px' }}>
        <Banner
          title={i18n.translate(
            'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.upgradingTitleBanner'
          )}
          status="info"
          action={{
            loading: true
          }}
        />
      </div>
    );
  }
}

export default withI18n()(UpgradingBanner);
